module.exports = __webpack_public_path__ + "img/RoundTable.b679bab8.svg";